import React from "react";
import { NavLink } from "react-router-dom";
import { ExitIcon } from "@radix-ui/react-icons";
import { Button } from "components/ui/button";

/** Logout control when `showLinks` is false (code login / master access flow). */
const MasterAccessLogoutFooter = ({ collapsed }) => {
  if (collapsed) {
    return (
      <div className="w-full flex flex-col items-start pl-5 justify-center absolute bottom-2">
        <NavLink to="/login">
          <Button
            variant="outline"
            className="">
            <ExitIcon aria-hidden />
          </Button>
        </NavLink>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col items-start pl-2 pt-2 justify-center">
      <NavLink to="/login">
        <Button
          className="h-10 px-4 flex gap-2"
          variant="outline">
          <span className="text-[#1b1c1b] text-[14.95px] font-normal font-['Roboto'] leading-[17.94px]">
            Logout
          </span>
          <ExitIcon aria-hidden />
        </Button>
      </NavLink>
    </div>
  );
};

export default MasterAccessLogoutFooter;
